import React from "react"
import styled from "styled-components"
import { Copy } from "../../styles/typography"
import { MainButton } from "../../styles/buttons"
import { StepContainer } from "../../styles/reusables"
import { navigate } from "gatsby"

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    min-width: 150px;
  }

  :nth-child(1) {
    margin-right: 5px;
  }
  :nth-child(2) {
    margin-left: 5px;
  }

  @media only screen and (max-width: 800px) {
    flex-direction: column;
    height: 140px;
  }
`

const DeveloperHire = ({ setStep }) => (
  <StepContainer>
    <Copy>Choose an option from the choices below?</Copy>
    <Actions>
      <MainButton onClick={() => setStep(2)} whileHover={{ scale: 1.01 }}>
        Hire a developer
      </MainButton>
    </Actions>
  </StepContainer>
)

export default DeveloperHire
